/**
 * Utility functions for managing leadId persistence in localStorage
 * These functions are used to prevent duplicate lead creation during form submissions
 */

import { safeSessionStorage } from 'utils/storage/safeStorage';

// Constant for localStorage leadId key
export const TEMP_LEAD_ID_KEY = 'temp_leadId';

/**
 * Retrieves the temporary leadId from localStorage
 * @returns The stored leadId or null if not found
 */
export const getTempLeadId = (): string | null => safeSessionStorage.getItem(TEMP_LEAD_ID_KEY);

/**
 * Stores the leadId in localStorage for persistence across form submissions
 * @param leadId The leadId to store
 */
export const setTempLeadId = (leadId: string): void => safeSessionStorage.setItem(TEMP_LEAD_ID_KEY, leadId);

/**
 * Removes the temporary leadId from localStorage
 * Usually called after successful form submission
 */
export const clearTempLeadId = (): void => safeSessionStorage.removeItem(TEMP_LEAD_ID_KEY);
